import { render, staticRenderFns } from "./reward_program.vue?vue&type=template&id=aed5f0dc"
import script from "./reward_program.vue?vue&type=script&setup=true&lang=js"
export * from "./reward_program.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports